var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMouseClick = function SvgMouseClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.293 10.293a1 1 0 011.11-.208l10 4.4a1.001 1.001 0 01-.15 1.882l-3.87 1.015-1.016 3.872a1 1 0 01-1.882.148l-4.4-10a1 1 0 01.208-1.109m-3.948 5.946a1 1 0 111.414 1.414l-2.121 2.121a1 1 0 01-1.414-1.414zm-1.34-5.244a1 1 0 110 2h-3a1 1 0 010-2zm-.781-6.77a1 1 0 011.414 0l2.121 2.122A1 1 0 016.345 7.76L4.224 5.64a1 1 0 010-1.414m14.142-.006a1 1 0 111.413 1.414l-2.12 2.12a1 1 0 01-1.415-1.413zM11 5V2a1 1 0 012 0v3a1 1 0 01-2 0"
  })));
};
export default SvgMouseClick;